.itemHeader {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.5em;
  white-space: nowrap;
}

.remove {
  color: var(--black);
  margin: 0;
  padding: 0.5em 1em;
  border: 0;
  background: transparent;
}
